import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs';
import { RoleService } from './role.service';
import { UserSettingsService } from '../../user-settings/services/user-settings.service';


/**
 * Guards route access based on whether the user is in dashboard mode and within specified roles.
 * If not in dashboard mode, the 'route.data.adminRoute' route is used if the user is within the specified role.
 * If not in dashboard mode and not in the specified role the 'route.data.defaultRoute'.
 * @todo This type was intended to be for October Demo only. It has been modified for Identity Server
 * adoption but it's purpose and implementation should be reviewed.
 * */
@Injectable()
export class DashboardModeRoleGuardService  {

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let result: boolean = false;

    if (Array.isArray(route.data.roles)) {
      const found = route.data.roles.some((value) => this.roleService.isInRole(value));
      if (found)
        result = true;
    }

    return this.userSettings.getUserSettings()
      .pipe(
      take(1),
      map((userSettings) => {

        if (userSettings.IsInMyDashboardMode) {
          this.router.navigate([route.data.defaultRoute]);
          return result;
        }

        /* Due to https://github.com/angular/angular/issues/18605
        * we cannot use redirectTo and canActivate on the route table
        * this code is a workaround allowing the RoleGuardService to be called with
        * additional parameters that allow navigation to take place
        * If this additional navigation is not required then don't set
        * the parameters and the guard will operate as normal
        */
        if (result && route.data.adminRoute) {
          this.router.navigate([route.data.adminRoute]);
        }

        if (!result && route.data.defaultRoute) {
          this.router.navigate([route.data.defaultRoute]);
        }
        return result;
      }));

  }

  constructor(private readonly router: Router,
    private readonly roleService: RoleService,
    private readonly userSettings: UserSettingsService
  ) {}

}
